import { useSelector } from 'hooks';

import { getSubscriptionData } from '../../../../../helpers/subscriptions';
import { getCurrenciesSign } from '../../../../../helpers/prices';

import { selectSubscriptions } from '../../../../../store/subscriptions/selectors';

const useDiscountModal = () => {
    const { cancellationCandidates, discountSubscription } = useSelector(selectSubscriptions);

    if (!cancellationCandidates || !discountSubscription) return {};

    const { product, subscription_period } = cancellationCandidates[0];

    return {
        currentSubscription: getSubscriptionData({ ...product, subscription_period }),
        discountOffer: getSubscriptionData(discountSubscription),
        currencySign: getCurrenciesSign(product.currency),
    };
};

export default useDiscountModal;
